import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Template} from "../../shared/template";
import {Router} from "@angular/router";

@Component({
  selector: 'app-template-item',
  templateUrl: './template-item.component.html',
  styleUrls: ['./template-item.component.scss']
})
export class TemplateItemComponent implements OnInit {

  @Input() item;
  @Output() deleteTemplateEvent = new EventEmitter();
  @Output() createStoryboardFromTemplateEvent = new EventEmitter();
  @Output() duplicateTemplateEvent = new EventEmitter();

  constructor(private router: Router) { }

  ngOnInit() {
  }

  delete() {
    this.deleteTemplateEvent.next(this.item);
  }

  open(item: Template) {
    this.router.navigate(['/template', item.id])
  }

  createStoryboardFromTemplate() {
    this.createStoryboardFromTemplateEvent.next(this.item);
  }

  duplicate() {
    this.duplicateTemplateEvent.next(this.item);
  }

}



// WEBPACK FOOTER //
// ./src/app/template/template-list/template-item/template-item.component.ts